var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[(_vm.reload)?_c('iframe',{staticClass:"formInstance",staticStyle:{"height":"100vh"},attrs:{"id":"formInstance","src":_vm.src,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }